module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><path fill=\"#8C8C8C\" fill-rule=\"evenodd\" d=\"M9.678 6.722C9.353 5.167 8.053 4 6.5 4S3.647 5.167 3.322 6.722h-2.6c-.397 0-.722.35-.722.778 0 .428.325.778.722.778h2.6C3.647 9.833 4.947 11 6.5 11s2.853-1.167 3.178-2.722h2.6c.397 0 .722-.35.722-.778 0-.428-.325-.778-.722-.778h-2.6zM4.694 7.5c0-1.09.795-1.944 1.806-1.944 1.01 0 1.806.855 1.806 1.944 0 1.09-.795 1.944-1.806 1.944-1.01 0-1.806-.855-1.806-1.944z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./cycle_analytics/svg/icon_branch.svg
// module id = ./cycle_analytics/svg/icon_branch.svg
// module chunks = pages.projects.cycle_analytics.show